import { useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { RouteContextParams } from 'modules/custom_resources/lib/RouteContextParams'
import CustomTableDestroyPage from 'modules/custom_resources/pages/Customizations/CustomTableDestroy'

const DestroyPage = () => {
  const { navigation } = useNavigation()

  const { schemaId } = useOutletContext<RouteContextParams>()

  const back = {
    href: navigation.settings.customizations.customTablesId.fullPath({ id: schemaId }),
  }

  return <CustomTableDestroyPage back={back} schemaId={schemaId} />
}

export default DestroyPage
